import React  from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
// Ust
import { useInvAF } from "../../../../St/Reviews/UseStyle";
// csG
import { stElemnt } from "../../../../St/Reviews/cStyle";

import { colors, Container, makeStyles, Typography } from "@material-ui/core";
import { useBody } from "../../../Invs/invCompany/style";
import { txtA, txtE } from "../../../../Label/Lbl";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
const BodyVat = (props) => {
  const cls = useRptAF();
//   const { onUnmountComplete, data } = props;
  const { onUnmountComplete, data ,isFullPage,isLast,found} = props;

 
  const clas = useInvAF();
  const calssBody = useBody();

  const cellS = {

    padding: "0px 0px",
    textAlign: "right",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.7rem",
    width: "600px",
    fontFamily: "Amiri-Regular",
    fontWeight:"bold",
    paddingRight:"0.5rem"

  };
  const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  var columns = [
    { title: "اسم البند", field: "Band_Name", cellStyle: cellS },  
    { title:"المبلغ", field: "Col_1" },
    { title:"مبلغ التعديل", field: "Col_2" },
    { title:"مبلغ ضريبة القيمة المضافة", field: "Col_3" },

  ];
  
  const data2 = data.map((row,i) => {
    return {
      ...row,
      Col_1: parseFloat(row.Col_1).toFixed(2),
      Col_2: parseFloat(row.Col_2).toFixed(2),
      Col_3: parseFloat(row.Col_3).toFixed(2),
    };
  });


  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container //className={cls.rootBdyup}
      style={{paddingTop:"0.5rem" ,direction: "rtl",border: "dotted 1px #393939",
        }}>
        <Grid
          item
          xs={12}
          style={{
          //  maxHeight: isFullPage ? sum >1 ? isLast?  "38em" :"40em" :"38em" :"38em" ,
           // minHeight: isFullPage ? sum >1 ? isLast?  "35em" :"40em" :"38em" :"38em" ,
          
           
          }}
        >
          <MaterialTable
            style={{ boxShadow: "none" }}
            // style={{direction:'ltr'}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom:"2px",
                border: "solid 0px",
                border: "solid 0.1px",
               
                
              },
              paging: false,
             // headerStyle: { ...stElemnt.AF.header, backgroundColor: "grey" },
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },
              // maxBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
              // minBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            // columns={columns.map(column=>({
            //   ...column,
            //   title:column.title.split("\n").map((line,index)=>(
            //     <div key={index}>{line}</div>
            //   )),
             
            // }))}

            columns={columns}
            data={data2}
          />
        </Grid>
        {/* <Grid item xs={12}>
        </Grid> */}
      </Grid>
      
    </Grid>
  );
};

export default BodyVat;
